import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import styled, { ThemeProvider } from 'styled-components';
import { Head } from '@components';
import { GlobalStyle, theme } from '@styles';

const StyledMainContainer = styled.main`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h2 {
    color: var(--lightest-slate);
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }
`;

const StyledHomeButton = styled(Link)`
  ${({ theme }) => theme.mixins.bigButton};
  margin-top: 50px;
`;

const ComingSoon = ({ subdomain }) => (
  <>
    <Head title={subdomain} />

    <ThemeProvider theme={theme}>
      <GlobalStyle />

      <StyledMainContainer className="fillHeight">
        <h1>{subdomain}.ionwyn.com</h1>
        <h2 className="big-heading">Coming soon.</h2>
        <p>This corner of the site is still being built. Check back later.</p>
        <StyledHomeButton to="/">Back to ionwyn.com</StyledHomeButton>
      </StyledMainContainer>
    </ThemeProvider>
  </>
);

ComingSoon.propTypes = {
  subdomain: PropTypes.string.isRequired,
};

export default ComingSoon;
